var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2251.1,4677.4c-373.3-182.2-431.4-212.1-431.4-217.5c0-2.7,454.3-237.7,1010.7-523c555.5-284.4,1016.8-523.8,1025.6-531.7 c14.1-12.3,15-51.1,15-578.4c0-526.5-0.9-567-15-583.7c-22-24.7-420-230.6-446.4-230.6c-50.2,0-49.3-11.4-49.3,585.5l-0.9,545.8 l-1030,530.9l-1030.9,531.7l-425.2-211.3c-354.8-176.1-427.9-216.6-445.5-241.2l-21.2-29.1l-2.7-1148.9 c-0.9-632.1,0-1157.6,2.7-1168.2c13.3-54.6,25.5-61.7,1073.2-585.5C2413.2,354.9,2505.6,310.9,2546.1,310 c40.5,0,116.1,35.3,1052,499.1c554.6,275.6,1024.7,509.7,1045.8,522c22,13.3,44,35.3,54.6,56.3c17.6,34.3,17.6,51.9,17.6,1177.1 c0,1070.5-0.9,1144.5-15.8,1173.5c-14.1,29.1-75.8,60.7-1053.7,549.4c-794.1,396.1-1048.5,519.5-1078.4,522 C2531,4813,2507.2,4803.2,2251.1,4677.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.4e14bf2d9787766c16f3618ee48a90c7.svg";
export { ForwardRef as ReactComponent };